import { render, staticRenderFns } from "./NewDocOption.vue?vue&type=template&id=563a87fc"
import script from "./NewDocOption.vue?vue&type=script&lang=js"
export * from "./NewDocOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports